module.exports = __webpack_public_path__ + "media/camila.fa3e25c9.mp3";